import { css } from "@emotion/react";

export const linkGroupStyles = {
  container: css({
    display: "flex",
    flexDirection: "column",
    gap: 8,
    maxWidth: `calc(100vw / 3.5)`,
  }),
  linkText: css({
    color: "rgb(191, 191, 191)",
    "&:hover, &:focus": {
      color: "white",
      textDecoration: "underline",
    },
  }),
  linkWithSuperTitle: css({
    marginTop: 20,
  }),
  footerLinkButtons: css({
    textAlign: "left",
  }),
};
